
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/content.module.css'

import { getLayout } from '../../components/sg/Layout'
import Header from '../../components/Header'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import Link from 'next/link'
import Image from 'next/image'
import Footer from '../../components/sg/Footer'
import Cards from '../../components/sg/Cards'
import Head from 'next/head'
import { useRouter } from 'next/router'

export default function Pricing () {
  const { t } = useTranslation('main')
  const router = useRouter()
  const { locale } = router
  const c = classNames.bind(style)
  const fiatCurrency = 'SGD'

  return (
    <>
      <Head>
        <title>{t('pricing-pagetitle')}</title>
      </Head>
      <Header showLogo />
      <div className={c('content')}>
        <div className={c('hero')}>
          <Image src='/images/goldbars.jpg' layout='fill' alt='Photo of Gold Bars' />
        </div>
        <div className={c('inner')}>
          <div className={c('single')}>
            <h3>{t('pricing-title')}</h3>
            <p>
              {t('pricing-description')}
            </p>
          </div>
          <div className={c('split')}>
            <div>
              <h4>{t('pricing-fees-header')}</h4>
              <table>
                <tbody>
                  <tr>
                    <td>{t('pricing-buypremium-gold')}</td>
                    <td>{(0.02).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-sellpremium-gold')}</td>
                    <td>{(0).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-buysellspread', { spread: (0.02).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 }) })}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-storagefee-gold')}</td>
                    <td>{(0.0035).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-storagefee-note')}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-storagefee-gold-minimum')}</td>
                    <td>{(0.1).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}g</td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-storagefee-due')}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-sg-banktransfer')}</td>
                    <td>{(0).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-intl-banktransfer')}</td>
                    <td>{(0).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-banktransfer-note')}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-creditcard')}</td>
                    <td>{(0.035).toLocaleString(locale, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-creditcard-note')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h4>{t('pricing-buyselllimits-title')}</h4>
              <table>
                <tbody>
                  <tr>
                    <td>{t('pricing-minimumpurchasesale-gold')}</td>
                    <td>{(0.01).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}g</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-maximumdailypurchasesale-gold')}</td>
                    <td>{(200000).toLocaleString(locale, { style: 'currency', currency: fiatCurrency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-maximumunfundedpurchase-gold')}</td>
                    <td>{(20000).toLocaleString(locale, { style: 'currency', currency: fiatCurrency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-unfundedpurchase-note')} <a href='https://www.silverbullion.com.sg/Info/ScheduleOfCharges#charges-late-payment-cancellation' target='_blank' rel='noopener noreferrer'>{t('pricing-unfundedpenalty-link')}</a></td>
                  </tr>
                </tbody>
              </table>
              <h4>{t('pricing-depositwithdrawallimit-header')}</h4>
              <table>
                <tbody>
                  <tr>
                    <td>{t('pricing-minimum-deposit')}</td>
                    <td>{(0.01).toLocaleString(locale, { style: 'currency', currency: fiatCurrency, currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-maximumundepositwithdrawal')}</td>
                    <td>{(999999.99).toLocaleString(locale, { style: 'currency', currency: fiatCurrency, currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                  <tr>
                    <td>{t('pricing-minimumwithdrawal')}</td>
                    <td>{(10).toLocaleString(locale, { style: 'currency', currency: fiatCurrency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                  </tr>
                  <tr>
                    <td><br /><br /><b>{t('pricing-initialbalancelimit')}</b></td>
                    <td><br /><br /><b>{(20000).toLocaleString(locale, { style: 'currency', currency: fiatCurrency, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</b></td>
                  </tr>
                  <tr>
                    <td colspan={2} class={c('subtext')}>{t('pricing-initialbalancelimit-note')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className={c('single')}>
            <h4>{t('pricing-redemption-header')}</h4>
            <p>
              {t('pricing-redemption-body-1')} <Link href='/sg/contact'><a>{t('pricing-redemption-bullionshopsg')}</a></Link>
            </p>
            <p>
              {t('pricing-redemption-body-2')}
            </p>
            <p>
              {t('pricing-redemption-body-3')}<br /><br />
              <code style={{ textAlign: 'center', display: 'block' }}>{t('pricing-redemption-calculation')}</code>
            </p>
          </div>
          <div className={c('promotion')}>
            <br /><br /><br />
            {t('banner-mission-1')}<br />
            {t('banner-mission-2')}<br />
            <br />
            <br />
            <Link href='/signup'>
              <button className='goldenshimmer' title={t('banner-signup-button-title')}>{t('banner-signup-button')}</button>
            </Link>
            <span className={c('termsnote')}>{t('banner-signup-subtext')}</span>
          </div>
        </div>
      </div>
      <Cards />
      <Footer />
    </>
  )
}

Pricing.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/pricing',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  